import { render, staticRenderFns } from "./LocaleTable.vue?vue&type=template&id=08206ba8&scoped=true"
import script from "./LocaleTable.vue?vue&type=script&lang=js"
export * from "./LocaleTable.vue?vue&type=script&lang=js"
import style0 from "./LocaleTable.vue?vue&type=style&index=0&id=08206ba8&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08206ba8",
  null
  
)

export default component.exports